module.exports = __webpack_public_path__ + "img/linshare-logo-white.bd9d67ff.svg";